import { render, staticRenderFns } from "./SmallModalWrapper.vue?vue&type=template&id=f23910fa"
import script from "./SmallModalWrapper.vue?vue&type=script&lang=ts"
export * from "./SmallModalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports